import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { NanaeHeader, NanaeFooter } from "@/components/qv3";
import { PlaceholderBody } from "@/components/qorum/PlaceholderBody";
import { socialMeta } from "@/lib/seo-meta";

export const Route = createFileRoute("/chat/$num")({
  head: ({ params }) => ({
    meta: [{ title: "Dossier — Hōjin" }, { name: "robots", content: "noindex, nofollow" },
      ...socialMeta({
        title: "Dossier — Hōjin",
        description: "Dossier — Hōjin",
        url: `https://hojin.ai/chat/${params.num}`,
        image: "conseil",
        card: "summary_large_image",
      }),
    ],
    links: [{ rel: "canonical", href: `https://hojin.ai/chat/${params.num}` }],
  }),
  component: ChatPage,
});

function ChatPage() {
  const { num } = Route.useParams();
  return (
    <ProtectedRoute>
      <div className="nanae-page qv3-dark">
        <NanaeHeader variant="minimal" title={`Dossier N° ${num}`} />
        <PlaceholderBody title={`Dossier N° ${num}`} subtitle="La Table — Sprint 6 à venir." />
        <NanaeFooter variant="minimal" />
      </div>
    </ProtectedRoute>
  );
}
